import PropTypes from 'prop-types';
import React from 'react';
import ImagePlaceholdered from '../../../shared/image-placeholdered';
import lessRequire from '../../../../config/less-require-resolver';

lessRequire('modules/dashboard/components/on-start-popup.less');

export default function WasDeletedDomainPopup({intl, data, onClose}) {
	const redirectToCampaign = (campaignId) => {
		window.open(`/campaigns/${campaignId}`, '_blank');
	};
	const redirectToDomain = (domain) => {
		window.open(`https://${domain}`, '_blank');
	};
	return (
		<div className="on-start-modal__container">
			<div className='on-start-modal__content-container'>
				<div className="on-start-modal__title">
					<h2 className='font-proxima-nova-bold on-start-modal__title'>
						{intl('В ряде потоков были обновлены страницы в связи с потерей актуальности предыдущих!')}
					</h2>
				</div>
				<div className='on-start-modal__gallery-container was-delete-domain-modal'>
					{Object.entries(data).map(([key, value], index) => {
						return (
							<div key={index}>
								<div className='on-start-modal__title
								on-start-modal__title_sticky
								font-proxima-nova-semibold
								was-delete-domain-modal-campaign-title
								'>
									<h1 onClick={() => redirectToCampaign(data[key][0].campaign_id)}>{key}</h1>
								</div>
								<div className='on-start-modal__gallery'>
									{value.map((item, itemIndex) => {
										return (
											<div
												key={itemIndex}
												className='on-start-modal__redirect-domain-container'
											>
												<div
													className='on-start-modal__item removed__item'
													// onClick={() => redirectToCampaign(item.campaign_id)}
												>
													<h3 className="font-proxima-nova-semibold">
														{intl('Устаревший')}
													</h3>
													<ImagePlaceholdered
														src={item.deleted_image}
														alt={item.type == 'landing' ? 'Landing Preview' : 'Transit Preview'}
														className='on-start-modal__item-image'
													/>
													<h4 className="font-proxima-nova-semibold">
														{item.deleted_title}
													</h4>
													<h4 className="font-proxima-nova-semibold">
														{item.deleted_domain}
													</h4>
												</div>
												<div className='on-start-modal__arrow'></div>
												<div className='on-start-modal__item'
													onClick={() => redirectToDomain(item.new_domain)}
												>
													<h3 className="font-proxima-nova-semibold">
														{intl('Обновленный')}
													</h3>
													<ImagePlaceholdered
														src={item.new_image}
														alt={item.type == 'landing' ? 'Landing Preview' : 'Transit Preview'}
														className='on-start-modal__item-image'
													/>
													<h4 className="font-proxima-nova-semibold">
														{item.new_title}
													</h4>
													<h4 className="font-proxima-nova-semibold">
														{item.new_domain}
													</h4>
												</div>
											</div>
										);
									}
									)}
								</div>
							</div>
						);
					})}
				</div>
				<div className='on-start-modal__button-wrap'>
					<button onClick={() => onClose('wasDeletedOfferDomain')}>OK</button>
				</div>
			</div>
		</div>
	);
}

WasDeletedDomainPopup.propTypes = {
	data: PropTypes.object
};


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/dashboard/components/popups/was-deleted-domain-popup.js